'use strict';

var React = require('react');
var cn = require('classnames');
var tslib = require('tslib');
var styled = require('styled-components');
var lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var lightThemeColors__namespace = /*#__PURE__*/_interopNamespace(lightThemeColors);

var StyledIcon = styled__default["default"].svg.withConfig({ displayName: "StyledIcon", componentId: "-jddg33" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n"], ["\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n"])), function (p) { return "".concat(p.size, "px"); }, function (p) { return "".concat(p.size, "px"); });
var StyledIconPath = styled__default["default"].path.attrs(function (p) { return ({
    d: p.path,
}); }).withConfig({ displayName: "StyledIconPath", componentId: "-15m077l" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: ", ";\n"], ["\n  fill-rule: evenodd;\n  clip-rule: evenodd;\n  fill: ", ";\n"])), function (p) { var _a, _b, _c; return (_c = (_b = (_a = p.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b[p.color]) !== null && _c !== void 0 ? _c : lightThemeColors__namespace[p.color]; });
var templateObject_1, templateObject_2;

var Icon = function (_a) {
    var path = _a.path, _b = _a.size, size = _b === void 0 ? 24 : _b, _c = _a.color, color = _c === void 0 ? 'base700' : _c, variant = _a.variant, className = _a.className, style = _a.style;
    return (React__default["default"].createElement(StyledIcon, { viewBox: "0 0 24 24", size: size, className: cn__default["default"](variant, className), style: style },
        React__default["default"].createElement(StyledIconPath, { color: color, path: path })));
};

exports.Icon = Icon;
//# sourceMappingURL=icon-e3ab87ed.js.map
